import React from 'react';

const SkeletonBar = ({ width = '100%', height = '8px', style = {} }) => (
  <div className="axigon-skeleton" style={{ height, width, ...style }} />
);

export default SkeletonBar;
